export default "__VITE_ASSET__FTuEcHrL__"